import Vue from 'vue'
import {on} from 'element-ui/lib/utils/dom'

const nodeList = []
const ctx = '@@clickoutsideContext'

let startClick

!Vue.prototype.$isServer && on(document, 'mousedown', e => (startClick = e))

!Vue.prototype.$isServer && on(document, 'mouseup', e => {
    nodeList.forEach(node => node[ctx].documentHandler(e, startClick))
})

export default {
    bind (el, binding, vnode) {
        nodeList.push(el)
        // const id = nodeList.push(el) - 1
        
        if (!el.id) {
            el.setAttribute('id', `${ctx}_${Math.floor(Math.random() * 1000000)}`)
        }
        
        const id = el.id
        const documentHandler = function (mouseup, mousedown) {
            if (!vnode.context ||
                el.contains(mouseup.target) ||
                (vnode.context.popperElm &&
                    (vnode.context.popperElm.contains(mouseup.target) ||
                        vnode.context.popperElm.contains(mousedown.target)))) return

            if (binding.expression &&
                el[ctx].methodName &&
                vnode.context[el[ctx].methodName]) {
                vnode.context[el[ctx].methodName](mouseup)
            } else {
                el[ctx].bindingFn && el[ctx].bindingFn(mouseup)
            }
        }
        el[ctx] = {
            id,
            documentHandler,
            methodName: binding.expression,
            bindingFn: binding.value
        }
    },

    update (el, binding) {
        el[ctx].methodName = binding.expression
        el[ctx].bindingFn = binding.value
    },

    unbind (el) {
        let len = nodeList.length

        for (let i = 0; i < len; i++) {
            if (nodeList[i][ctx].id === el[ctx].id) {
                nodeList.splice(i, 1)
                break
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/directives/clickoutside.js